import LoadingSpin from '../LoadingSpin';
import NotificationItem from './notification.item.component';

const LOAD_MORE_THRESHOLD_PX = 80;

export default function NotificationList({
    items = [],
    status = 'loading',
    loadingMore = false,
    loadMoreFailed = false,
    hasMore = false,
    onLoadMore = () => { },
    onRetry = () => { },
    onItemClick = () => { },
}) {

    const handleScroll = (event) => {
        if (!hasMore || loadingMore || loadMoreFailed)
            return;

        const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
        const distanceToBottom = scrollHeight - scrollTop - clientHeight;

        if (distanceToBottom <= LOAD_MORE_THRESHOLD_PX)
            onLoadMore();
    }

    if (status === 'loading')
        return (
            <div className="flex justify-center py-8">
                <LoadingSpin />
            </div>
        );

    if (status === 'error')
        return (
            <div className="px-4 py-8 text-center">
                <p className="text-[13px] text-black/[.56]">
                    Não foi possível carregar suas notificações.
                </p>
                <button
                    type="button"
                    onClick={onRetry}
                    className="mt-3 text-[13px] font-semibold text-primary hover:underline"
                >
                    Tentar novamente
                </button>
            </div>
        );

    if (items.length === 0)
        return (
            <div className="px-4 py-[30px] text-center text-[13px] text-black/40">
                Nenhuma notificação no momento
            </div>
        );

    return (
        <div
            data-testid="notification-list"
            onScroll={handleScroll}
            className="max-h-[62vh] overflow-y-auto overscroll-contain"
        >
            {items.map(notification => (
                <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onClick={onItemClick}
                />
            ))}

            {loadingMore && (
                <div className="flex justify-center py-3">
                    <LoadingSpin size="small" />
                </div>
            )}

            {loadMoreFailed && (
                <div className="px-4 py-3 text-center">
                    <button
                        type="button"
                        onClick={onLoadMore}
                        className="text-[12.5px] font-semibold text-primary hover:underline"
                    >
                        Não foi possível carregar mais. Tentar novamente
                    </button>
                </div>
            )}
        </div>
    );
}
